import React, { useState } from 'react'
import { ChevronDown } from 'lucide-react'
import { objectivesForDomain, NUMBERED_OBJECTIVES } from '../content/objectivesScreen'

// The session's learning objectives, carried INTO the task doc.
//
// They were previously shown on one screen at the start of the session and then never
// again, so by the time a participant was working they had no way to see what the task
// was for. This pins the objectives this task practises to the top of its description,
// with the rest one click away — the numbers match the objectives screen, so "objective
// 3" means the same thing everywhere.
//
// The warm-up has domain 'screening' and matches nothing; it renders nothing at all
// rather than an empty box, since no session objective is being taught there.
export default function TaskObjectives ({ domain }) {
  const [showAll, setShowAll] = useState(false)
  const mine = objectivesForDomain(domain)
  if (!mine.length) return null

  const others = NUMBERED_OBJECTIVES.filter(o => o.domain !== domain)

  return (
    <aside className="task-obj">
      <div className="task-obj__head">
        <span>What this task is practising</span>
      </div>
      <ol className="task-obj__list">
        {mine.map(o => (
          <li key={o.n} className="task-obj__item">
            <span className="task-obj__n">{o.n}</span>
            <span>{o.text}</span>
          </li>
        ))}
      </ol>

      <button
        className={`task-obj__more${showAll ? ' is-open' : ''}`}
        onClick={() => setShowAll(v => !v)}
      >
        <ChevronDown size={13} strokeWidth={2.4} />
        {showAll ? 'Hide the other objectives' : `All ${NUMBERED_OBJECTIVES.length} session objectives`}
      </button>

      {showAll && (
        <ol className="task-obj__list task-obj__list--rest">
          {others.map(o => (
            <li key={o.n} className="task-obj__item">
              <span className="task-obj__n">{o.n}</span>
              <span>{o.text}</span>
            </li>
          ))}
        </ol>
      )}
    </aside>
  )
}
